<template>
  <div v-if="page == 'home'">
    <div class="col-12 px-0">
      <div class="d-flex align-items-center justify-content-between mb-4">
        <h1 class="h3 mb-0 text-gray-800">
          Bem-vindo(a) à Central de Atendimento SUAS Fácil
        </h1>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-3">
        Uma grande parcela das solicitações podem ser resolvidas na área de
        Tutoriais ou realizando uma pesquisa em Perguntas frequentes. Se ainda
        assim não encontrar solução para sua dúvida, não hesite em abrir uma
        solicitação de Suporte para que o atendimento possa ser o mais breve e
        efetivo possível.
      </div>
    </div>

    <div class="row">
      <h1 class="font-weight-bold text-gray-800 mt-3 col-12">
        Agenda de Atendimentos
      </h1>
      <div class="col-md-4">
        <b-card-group deck>
          <b-card class="shadow text-center">
            <b-link to="/dashboard/agenda-atendimentos" href="#" class="card-link">
              <div>
                <img src="../../../../../public/images/agenda.png" alt="Agenda" style="height: 48px">
              </div>
              <div class="mt-2">
                 Agenda de Atendimentos
              </div>
            </b-link>
          </b-card>
        </b-card-group>
      </div>
      <div class="col-md-4">
        <b-card-group deck>
          <b-card class="shadow text-center">
            <b-link @click="openModalAgenda" class="card-link">
              <div>
                <img src="/images/e-learning.png" alt="Agenda" style="height: 48px">
              </div>
              <div class="mt-2">
                 Vídeo tutorial
              </div>
            </b-link>
          </b-card>
        </b-card-group>
      </div>
    </div>

    <div class="row">
      <div class="col-12 mb-2 mt-3">
        <h1 class="font-weight-bold text-gray-800">
          Perguntas Frequentes e Tutoriais
        </h1>
      </div>
      <div class="col-md-12">
        <b-card-group deck>
          <b-card class="shadow text-center">
            <b-link href="#" disabled class="card-link">
              <i class="mdi mdi-comment-question mdi-48px"></i>
              <br />
              Perguntas Frequentes
              <br />
              <small class="text-muted">Respostas</small>
            </b-link>
          </b-card>
          <b-card class="shadow text-center">
            <b-link
            @click="openModalVideo"
              class="card-link"
            >
              <i class="mdi mdi-play-circle mdi-48px text-danger"></i>
              <br />
              Tutoriais em Vídeos
              <br />
              <small class="text-muted">Explicando o Sistema</small>
            </b-link>
          </b-card>
          <b-card class="shadow text-center">
            <b-link @click="page = 'update'" target="_blank" class="card-link">
              <i class="mdi mdi-cellphone-arrow-down mdi-48px text-success"></i>
              <br />
              Central de Atualizações
              <br />
              <small class="text-muted">Últimas atualizações do sistema</small>
            </b-link>
          </b-card>
          <b-card class="shadow text-center">
            <b-link
              href="https://comunidade.suasfacil.com.br"
              target="_blank"
              class="card-link">
              <i class="mdi mdi-school mdi-48px"></i>
              <br />
              Comunidade
              <br />
              <small class="text-muted">Acesse as aulas</small>
            </b-link>
          </b-card>
        </b-card-group>
      </div>
    </div>
    <div class="col-md-12 p-0 mt-3">
      <h1 class="font-weight-bold text-gray-800">
        Manuais - SUAS FÁCIL
      </h1>
    </div>
    <div class="row my-3 p-0 alert mx-0">
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA  - Unidade_ CRAS - 2026.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="Manual CRAS"
                width="100"
              />
            </div>
            <div class="col-8">Manual CRAS</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA - Unidade_ CREAS - 2026.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="Manual CREAS"
                width="100"
              />
            </div>
            <div class="col-8">Manual CREAS</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/Manual RMA - Unidade_ CENTRO POP - 2026.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="Manual CENTRO POP"
                width="100"
              />
            </div>
            <div class="col-8">Manual CENTRO POP</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`${urlbase}manual/manual-suas-facil.pdf`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/pdf.svg`"
                alt="Manual do Sistema Suas Fácil"
                width="100"
              />
            </div>
            <div class="col-8">Manual do Sistema Suas Fácil</div>
          </div>
        </a>
      </div>
      <div class="col-md-4 col-sm-12 d-flex align-items-stretch">
        <a
          :href="`https://treinamento.suasfacil.com.br/flip`"
          target="_blank"
          class="card card-body mb-0 row"
        >
          <div class="row d-flex align-items-center">
            <div class="col-4">
              <img
                :src="`${urlbase}img/files/sql.svg`"
                alt="Manual do Sistema Suas Fácil"
                width="100"
              />
            </div>
            <div class="col-8">Manual do Sistema Suas Fácil <br><small>Versão Flip</small></div>
          </div>
        </a>
      </div>
    </div>
    <div class="row">
        <div class="col-md-12 mt-3">
          <h1 class="font-weight-bold text-gray-800">
            Fale conosco
          </h1>
          <b-card-group deck>
            <b-card class="text-center shadow">
              <a :href="`${urlbase}dashboard/suportes`" class="card-link">
                <i class="mdi mdi-ticket-account mdi-48px text-warning"></i>
                <br />
                Chamados de Suporte
                <br />
                <small class="text-muted">Resolução de Problemas</small>
              </a>
            </b-card>
            <b-card class="shadow text-center">
              <a
                :href="`${urlbase}dashboard/ouvidoria`"
                target="_blank"
                class="card-link"
              >
                <i class="mdi mdi-information mdi-48px"></i>
                <br />
                Ouvidoria
                <br />
                <small class="text-muted">Sugestão ou Reclamação</small>
              </a>
            </b-card>
          </b-card-group>
      </div>
    </div>
    <div class="row mt-3">
      <!-- <loading-animation
        :active.sync="loading"
        :is-full-page="false"
        :opacity="1"
        color="#5895ff"
      /> -->
      <!-- <div class="col-md-12">
        <h4>Artigos - SUAS FÁCIL</h4>
      </div>
      <div class="row px-3 row-cols-1 row-cols-md-2 g-4">
        <div class="col" v-for="(post, index) in posts" :key="index">
          <b-card
            :img-src="
              post._embedded['wp:featuredmedia'][0]['media_details']['sizes'][
                'thumbnail'
              ]['source_url']
            "
            :img-alt="post.title.rendered"
            img-left
            class="shadow"
          >
            <b-card-text>
              <h3>
                <a :href="post.link" target="_blank">
                  {{ post.title.rendered }}
                </a>
              </h3>
            </b-card-text>
          </b-card>
        </div>
      </div>
      <div class="col-md-12 text-center">
        <a
          href="https://suasfacil.com.br/blog"
          target="_blank"
          class="btn btn-primary"
          >Acessar mais artigos</a
        >
      </div> -->
    </div>
    <ModalVideos :item="item" title="Tutoriais em vídeos - explicando o sistema" />
    <ModalVideoAgenda :item="item" title="Agendamento - vídeo tutorial" />
    <Footer />
  </div>
  <Atualizacao v-else @voltar="page = 'home'" />
</template>

<script>
import Footer from "./includes/Footer";
import Atualizacao from "./includes/Atualizacao";
import ModalVideos from "./includes/ModalVideos.vue";
import ModalVideoAgenda from "./includes/ModalVideoAgenda.vue";
export default { components: { Footer, Atualizacao, ModalVideos, ModalVideoAgenda },
  name: "CentralAtendimento",
  metaInfo() {
    return {
      title: this.$i18n.t("Central de Atendimento"),
    };
  },
  data() {
    return {
      loading: true,
      page: "home",
      posts: [],
      urlbase: window.urlbase,
    };
  },
  mounted() {
    this.getPosts();
    if (this.$route.query.page) {
      this.page = this.$route.query.page;
    }
  },
  methods: {
    async getPosts() {
      //   https://suasfacil.com.br/?rest_route=/wp/v2/posts

      await fetch(
        "https://suasfacil.com.br/?rest_route=/wp/v2/posts&_embed&per_page=5"
      )
        .then((response) => response.json())
        .then((data) => {
          this.posts = data;
          this.loading = false;
        });
    },
    openModalVideo(){
      this.$bvModal.show("modal-videos");
    },
    openModalAgenda(){
      console.log('Abrindo video da agenda');
      this.$bvModal.show("modal-agenda");
    }
  },
};
</script>

<style>
.shadow {
  box-shadow: 0 0.5rem 1rem rgb(0 0 0 / 5%) !important;
}
</style>
